import React from "react";

function Header() {
  return (
    <header className="header">

      <div className="logo">
        <img src="/bcu-logo.png" alt="BCU Logo" />
      </div>

      <div className="title">
        <h1>BCU Question Papers</h1>
      </div>

      <div className="about">
        <a href="https://www.bcu.ac.in" target="_blank" rel="noopener noreferrer">
          About Us
        </a>
      </div>

    </header>
  );
}

export default Header;